import { DepartmentService } from "../../services/DepartmentService";

// initial state
const state = {
  modifiedDepartments: [],
  departmentsAreValid: false
};

// getters
const getters = {
  modifiedDepartments: (state: any) => state.modifiedDepartments,
  departmentsAreValid: (state: any) => state.departmentsAreValid
};

// actions
const actions = {
  setDepartmentsAreValid: (state: any, value: boolean) => {
    state.commit("setDepartmentsAreValid", value);
  },
  removeModifiedDepartment: (state: any, departmentId: number) => {
    let departments = state.rootGetters["departments/modifiedDepartments"];

    departments = departments.filter((department: any) => {
      return department.tempId !== departmentId;
    });

    state.commit("removeModifiedDepartment", departments);
  },
  setModifiedDepartments: (state: any, department: any) => {
    let departments = state.rootGetters["departments/modifiedDepartments"];
    const modifiedDepartment = department;

    departments = departments.filter((department: any) => {
      return department.tempId !== modifiedDepartment.tempId;
    });

    const updatedDepartments = [...departments, modifiedDepartment];

    state.commit("setModifiedDepartments", updatedDepartments);
  },
  saveDepartments: (state: any) => {
    const departments = state.rootGetters["departments/modifiedDepartments"];
    const customerMbeId = state.rootGetters["customer/customerMbeId"];

    departments.map((department: any) => {
      if (department.departmentId) {
        new DepartmentService()
          .updateDepartment(customerMbeId, department, department.departmentId)
          .then((res: any) => {});
      } else {
        new DepartmentService()
          .createDepartment(customerMbeId, department)
          .then((res: any) => {});
      }
    });
  }
};

// mutations
const mutations = {
  clearModifiedDepartments: (state: any) => {
    state.modifiedDepartments = [];
  },
  removeModifiedDepartment: (state: any, departments: any) => {
    state.modifiedDepartments = departments;
  },
  setModifiedDepartments: (state: any, departments: any) => {
    state.modifiedDepartments = departments;
  },
  setDepartmentsAreValid: (state: any, value: boolean) => {
    state.departmentsAreValid = value;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
